export default {
  form: {
    display_name: {
      label: 'Nome del ristorante',
      placeholder: 'Inserisci il nome del ristorante',
      help: 'Utilizzato sul contratto e sulle fatture',
    },
    store_address: {
      label: 'Indirizzo del punto vendita',
      placeholder: 'Cerca il tuo indirizzo',
      help: "Questo è l'indirizzo visibile ai tuoi clienti",
    },
    address: {
      label: 'Indirizzo',
      placeholder: 'Via + numero civico',
    },
    zip_code: {
      label: 'Codice postale',
      placeholder: 'Codice postale',
    },
    city: {
      label: 'Città',
      placeholder: 'Città',
    },
    state: {
      label: 'Provincia',
      placeholder: 'Seleziona provincia',
    },
    country: {
      label: 'Paese',
      help: "Per spostare il tuo ristorante in un altro paese, contatta l'assistenza",
    },
  },
  staff_notice:
    "Il personale del locale non può confermare il nome e l'indirizzo del ristorante. Chiedi al tuo onboarding manager di verificare questi dettagli.",
  toasts: {
    saved: 'Dettagli del punto vendita salvati',
    error: 'Impossibile salvare i dettagli del punto vendita',
  },
  buttons: {
    next: 'Avanti',
  },
};
